import { render, staticRenderFns } from "./BlockTimeForm.vue?vue&type=template&id=5bb20b84"
import script from "./BlockTimeForm.vue?vue&type=script&lang=js"
export * from "./BlockTimeForm.vue?vue&type=script&lang=js"
import style0 from "./BlockTimeForm.vue?vue&type=style&index=0&id=5bb20b84&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bb20b84')) {
      api.createRecord('5bb20b84', component.options)
    } else {
      api.reload('5bb20b84', component.options)
    }
    module.hot.accept("./BlockTimeForm.vue?vue&type=template&id=5bb20b84", function () {
      api.rerender('5bb20b84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/extras/offcanvas/BlockTimeForm.vue"
export default component.exports